import { getCasing } from './casing.js';
import { getLists } from './lists.js';
export const getAncestors = (configuration, allConfigs, traversed = {}, sourcePath = []) => {
    const ancestors = [];
    for (const parent of getParents(configuration, allConfigs)) {
        if (!parent.primaryRelationship)
            continue;
        const hash = `${parent.collection}:${parent.name}`;
        if (traversed[hash])
            continue;
        traversed[hash] = true;
        const parentSourcePath = [
            ...sourcePath,
            {
                collection: parent.collection,
                name: parent.name,
            },
        ];
        ancestors.push({
            collection: parent.collection,
            name: parent.collectionCasing.pluralCamel,
            sourcePath: parentSourcePath,
        });
        ancestors.push(...getAncestors(allConfigs[parent.collection], allConfigs, traversed, parentSourcePath));
    }
    return ancestors;
};
export const getDescendants = (configuration, allConfigs, traversed = {}, sourcePath = []) => {
    const descendants = [];
    for (const child of configuration.lists) {
        if (!child.primaryRelationship)
            continue;
        const hash = `${child.collection}:${child.name}`;
        if (traversed[hash])
            continue;
        traversed[hash] = true;
        const childSourcePath = [
            ...sourcePath,
            {
                collection: child.collection,
                name: child.name,
            },
        ];
        descendants.push({
            collection: child.collection,
            name: child.name,
            sourcePath: childSourcePath,
        });
        descendants.push(...getDescendants(allConfigs[child.collection], allConfigs, traversed, childSourcePath));
    }
    return descendants;
};
export const getRelations = (configuration, allConfigs) => {
    return {
        ancestors: getAncestors(configuration, allConfigs),
        descendants: getDescendants(configuration, allConfigs),
    };
};
export const getParents = (configuration, allConfigs) => Object.values(allConfigs).reduce((acc, config) => {
    const { name, lists } = config;
    getLists(lists, allConfigs).forEach((list) => {
        if (list.collection === configuration.name)
            acc.push({
                ...list,
                collection: name,
                collectionCasing: getCasing(config),
            });
    });
    return acc;
}, []);
//# sourceMappingURL=relatives.js.map